export default __webpack_public_path__ + "static/media/techxillencce.e4ac6824.png";